<template>
    <section class="product-bill m-b-30">
        <div class="title m-b-8 m-t-40">결제 금액</div>
        <div class="price-detail">
            <div class="row">
                <div class="key">정상가</div>
                <div class="value" v-html="`${price.originalPrice} 원`" />
            </div>
            <div class="row">
                <div class="key">{{ $moment().format('M') }}월 이벤트 할인</div>
                <div class="value" v-html="`-${price.eventDiscount} 원`" />
            </div>
            <div v-if="selectedCoupon" class="row">
                <div class="key">쿠폰 할인</div>
                <div class="value" v-html="`-${price.couponDiscount} 원`" />
            </div>
            <!-- <div class="row">
                <div class="key">포인트 할인</div>
                <div class="value" v-html="`-${Number(selectedPoint).toLocaleString()} 원`" />
            </div> -->

            <div v-if="selectedCoupon" class="row upper-line padding-top">
                <div class="key">할인가</div>
                <div
                    class="value"
                    v-html="
                        `${(
                            parseInt(price.originalPrice.replaceAll(',', '')) -
                            parseInt(price.eventDiscount.replaceAll(',', '')) -
                            parseInt(price.couponDiscount.replaceAll(',', ''))
                        ).toLocaleString()} 원`
                    "
                />
            </div>
            <div v-else class="row upper-line padding-top">
                <div class="key">할인가</div>
                <div
                    class="value"
                    v-html="
                        `${(
                            parseInt(price.originalPrice.replaceAll(',', '')) -
                            parseInt(price.eventDiscount.replaceAll(',', ''))
                        ).toLocaleString()} 원`
                    "
                />
            </div>

            <div class="row under-line">
                <div class="key">
                    <span>부가세(10%)</span>
                    <i @click="mouseOver = !mouseOver" class="material-icons-outlined">info</i>
                </div>
                <div class="value" v-html="`${price.tax} 원`" />
                <div class="info" v-if="mouseOver">
                    <p class="spoqa-f-bold">부가세 계산법</p>
                    <p>(상품 금액-할인액)*10%</p>
                </div>
            </div>

            <div v-show="selectedPoint > 0" class="row under-line padding-top">
                <div class="key">
                    <span>{{
                        selectedCoupon
                            ? '적립금 할인 적용 해제(적립금 사용하지 않음)'
                            : canUseMaxMileage
                            ? '적립금 사용(최대 사용한도 50%)'
                            : '보유한 적립금 전체 사용'
                    }}</span>
                </div>
                <div class="value" v-html="`${selectedPoint > 0 ? '-' : ''}${selectedPoint.toLocaleString()} 원`" />
            </div>

            <div class="row m-t-8">
                <div class="key c-black">최종 결제금액</div>
                <div class="value">
                    <span class="c-primary spoqa-f-bold">
                        {{ price.sellingPrice }}
                    </span>
                    <span>원</span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data: () => ({
        mouseOver: false,
        canUseMaxMileage: true,
        // initModalTriggerd: false,
    }),
    computed: {
        price() {
            return this.$store.getters.price
        },
        selectedCoupon() {
            return this.$store.getters.selectedCoupon
        },
        selectedPoint() {
            return this.$store.getters.selectedPoint
        },
        mileage() {
            // return false
            if (this.$store.getters.me) {
                return this.$store.getters.me.mileage
            } else {
                return 0
            }
        },
    },
    watch: {
        price: {
            handler(val) {
                // console.log('watch price', val)
                if (val.sellingPrice && Number(val.sellingPrice.replace(',', '')) > 0) {
                    this.handlePointSelection('price')
                }
            },
            immediate: true,
            deep: true,
        },
        mileage: {
            handler(val) {
                // console.log('watch mileage', val)
                this.handlePointSelection('mileage')
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        reCalculateSelectedPoint() {
            // 부가세 포함, 포인트 제외 가격
            const beforePointPrice =
                parseInt(this.price.originalPrice.replaceAll(',', '')) -
                parseInt(this.price.eventDiscount.replaceAll(',', '')) -
                (this.selectedCoupon ? parseInt(this.price.couponDiscount.replaceAll(',', '')) : 0) +
                parseInt(this.price.tax.replaceAll(',', ''))

            // console.log('beforePointPrice', beforePointPrice)
            if (
                this.selectedPoint < Math.floor(beforePointPrice / 2) ||
                this.selectedPoint > Math.floor(beforePointPrice / 2)
            ) {
                // 적립금 계산하기
                const maxPoint = Math.min(beforePointPrice / 2, this.mileage)
                // console.log('maxPoint', maxPoint)
                this.$store.commit('setSelectedPoint', maxPoint)
                if (maxPoint === this.mileage) {
                    this.canUseMaxMileage = false
                }
            }
        },
        handlePointSelection(from = '') {
            // console.log('handlePointSelection', from )
            const sellingPrice = Number(this.price.sellingPrice.replace(',', ''))
            console.log(
                'handlePointSelection',
                this.price.couponDiscount,
                sellingPrice,
                this.mileage,
                this.selectedPoint
            )
            if (!this.price.couponDiscount && sellingPrice > 0 && typeof this.mileage === 'number') {
                // coupon 할인 아님, 적립금을 결제금액의 최대 50%로 조정
                const selectedPoint = this.selectedPoint || 0
                // console.log('mileage', this.mileage, selectedPoint, sellingPrice )
                if (selectedPoint === 0 && this.mileage > 0) {
                    // 적립금 계산하기
                    this.reCalculateSelectedPoint()
                    // const maxPoint = Math.min(sellingPrice / 2, this.mileage)
                    // // console.log('maxPoint', maxPoint)
                    // this.$store.commit('setSelectedPoint', maxPoint)
                    // if (maxPoint === this.mileage) {
                    //     this.canUseMaxMileage = false
                    // }
                } else if (selectedPoint > 0 && this.mileage > 0) {
                    // 아마도 상품이 바뀐 경우로, 적립금 재계산이 필요함
                    this.reCalculateSelectedPoint()
                } else if (this.mileage <= 0) {
                    // 적립금이 없는 상태로, 적립금 사용 리셋
                    this.$store.commit('setSelectedPoint', 0)
                    this.canUseMaxMileage = false
                    // if (this.initModalTriggerd === false) {
                    //     this.initModalTriggerd = true
                    //     this.$modal.basic({
                    //         body:
                    //             '보유한 적립금이 없습니다. 적립금 얻는 방법은 메인 페이지의 ‘적립금’ 메뉴를 확인해주세요.',
                    //         buttons: [
                    //             {
                    //                 label: 'CONFIRM',
                    //                 class: 'btn-primary',
                    //             },
                    //         ],
                    //     })
                    // }
                }
            } else if (sellingPrice <= 0) {
                this.reCalculateSelectedPoint()
            } else if (this.price.couponDiscount) {
                // coupon 할인이라서 적립금 0 으로 만들어야함.
                if (this.selectedPoint > 0) {
                    this.$modal.basic({
                        body:
                            '쿠폰과 적립금은 동시에 사용할 수 없어, 적용된 적립금 할인이 해제되었습니다. 쿠폰 할인은 정상 적용되었습니다.',
                        buttons: [
                            {
                                label: 'CONFIRM',
                                class: 'btn-primary',
                            },
                        ],
                    })
                }
                this.$store.commit('setSelectedPoint', 0)
            }
        },
    },
    // mounted() {

    // }
}
</script>

<style scoped lang="scss">
.product-bill {
    .price-detail {
        .row {
            position: relative;
            font-size: 16px;
            line-height: 26px;
            padding-bottom: 8px;
            @include between;

            .info {
                position: absolute;
                width: 200px;
                background: $grey-01;
                bottom: -54px;
                left: 16px;
                z-index: 5;
                font-size: 12px;
                line-height: 20px;
                padding: 8px 12px;
                border-radius: 4px;
                border: 1px solid #94999e;
            }

            &.under-line {
                border-bottom: dashed $grey-03;
            }
            &.upper-line {
                border-top: dashed $grey-03;
            }

            &.padding-top {
                padding-top: 5px;
            }

            .key {
                color: $grey-06;
                @include center;
                i {
                    margin-left: 4px;
                    color: $grey-06;
                    font-size: 20px;
                }
            }
            .value {
                color: black;
            }
        }
    }
}
</style>
